import { AxiosError, HttpStatusCode } from "axios";

/**
 * Determines if an error is transient (temporary) and potentially retryable.
 * Transient errors include network failures, server errors (5xx), and timeouts.
 */
export const isTransientError = (error: unknown): boolean => {
  if (error instanceof AxiosError) {
    // No response = network failure
    if (!error.response) { return true; }

    // 5xx = server error
    if (error.response.status >= HttpStatusCode.InternalServerError) { return true; }

    // Timeout
    if (error.code === "ECONNABORTED") { return true; }
  }
  return false;
};
